var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "AutoHandover-Batch-Details"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('fieldset', [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingPrint
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPrint = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 float-right",
    staticStyle: {
      "margin-top": "3%"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.printBatch()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])])]), _vm._v(" "), (_vm.batchdatafound == true) ? _c('div', {
    attrs: {
      "id": "batchsheetContent"
    }
  }, [_c('br'), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print Date :")]), _vm._v(" " + _vm._s(_vm.printDate))]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Print By :")]), _vm._v(" " + _vm._s(_vm.printBy))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    staticStyle: {
      "border": "none !important"
    }
  }, [_c('strong', [_vm._v("Batch Type :")]), _vm._v(" " + _vm._s(_vm.category))])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Batch ID : ")]), _vm._v(_vm._s(_vm.BatchDetails.batchid))]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Created By : ")]), _vm._v(_vm._s(_vm.BatchDetails.createdby))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Origin : ")]), _vm._v(_vm._s(_vm.BatchDetails.createdAt))]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Created Date/Time: ")]), _vm._v(_vm._s(_vm.BatchDetails.createddate) + "  " + _vm._s(_vm.BatchDetails.createdtime))]), _vm._v(" "), (_vm.inscanFlag) ? _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("InScan Date/Time: ")]), _vm._v(_vm._s(_vm.BatchDetails.batchStatusChangeDate) + "  " + _vm._s(_vm.BatchDetails.batchStatusChangeTime))]) : _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("OutScan Date/Time: ")]), _vm._v(_vm._s(_vm.BatchDetails.batchStatusChangeDate) + "  " + _vm._s(_vm.BatchDetails.batchStatusChangeTime))])]), _vm._v(" "), (_vm.isEcomFlag == false) ? _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Paper Bag No:")]), _vm._v(" " + _vm._s(_vm.BatchDetails.paperbagno))])]) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.isEcomFlag) ? _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Bag Count:")]), _vm._v(" " + _vm._s(_vm.BatchDetails.Bagcount))]) : _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("AWB Count:")]), _vm._v(" " + _vm._s(_vm.BatchDetails.AWBcount))]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Scan Mode:")]), _vm._v(" " + _vm._s(_vm.BatchDetails.ScanMode || 'Bulk'))])]), _vm._v(" "), (_vm.isEcomFlag == false) ? _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("MPS Count:")]), _vm._v(" " + _vm._s(_vm.BatchDetails.MPScount))]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Shortage MPS Count:")]), _vm._v(" " + _vm._s(_vm.shortageCount))])]) : _vm._e(), _vm._v(" "), (_vm.isEcomFlag == true) ? _c('tr', [_c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Shortage Bag Count:")]), _vm._v(" " + _vm._s(_vm.shortageCount))])]) : _vm._e()])]), _vm._v(" "), (_vm.isEcomFlag == true) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("SR NO")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Bag No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Destination")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Group No")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Group Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Reason")])])]), _vm._v(" "), _vm._l((_vm.autoHandoverBatchData), function(data, index) {
    return _c('tr', {
      class: {
        'row-shortage': data.isShortage
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destination))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.shortageReasonLabel(data.reason) || '--'))])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.isEcomFlag == false) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("SR NO")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Parent AWB No")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("MPS ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Destination")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Reason")])])]), _vm._v(" "), _vm._l((_vm.autoHandoverBatchData), function(data, index) {
    return _c('tr', {
      class: {
        'row-shortage': data.isShortage
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentawb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mpsid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destination))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.shortageReasonLabel(data.reason) || '--'))])])
  })], 2)]) : _vm._e()]) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', [_vm._v("No record found")])])], 1)]), _vm._v(" "), _c('br')])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a291d710","hasScoped":true}!./src/views/components/AutoHandoverBatchDetailsPrint/AutoHandoverBatchDetailsPrint.html
// module id = 1890
// module chunks = 2